import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./ActivitiesCard.css";

const ActivitiesCard = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location

  if (!data || data.length === 0) {
    return <div className="activities-no-data">No activities available.</div>;
  }

  const handleCardClick = (id) => {
    // Use the current URL and append the id
    navigate(`${location.pathname}/${id}`);
  };

  return (
    <div className="activities-container">
      {data.map((activity) => (
        <div
          key={activity._id}
          className="activities-card"
          onClick={() => handleCardClick(activity._id)} // Redirect on click
        >
          <img
            src={activity.photo?.[0]?.url || "https://via.placeholder.com/150"}
            alt={activity.title}
            className="activities-image"
          />
          <div className="activities-info">
            <h3 className="activities-title">{activity.title}</h3>
            <p className="activities-details">{activity.details}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActivitiesCard;
